import { list, downloadData } from 'aws-amplify/storage';

const GetStories = async (folderPath) => {
    try {
        // console.log(folderPath);
        const result = await list({ path: ({ identityId }) => `private/${identityId}/stories/` });
        // console.log(result);

        const bodies = await Promise.all(
            result.items.map(async (file) => {
                if (file.path.endsWith(".json")) {
                    const downloadResult = await downloadData({
                        path: file.path,
                        // Alternatively, path: ({identityId}) => `protected/${identityId}/album/2024/1.jpg`
                    }).result;
                    const text = await downloadResult.body.text();
                    // Alternatively, you can use `downloadResult.body.blob()`
                    // or `downloadResult.body.json()` to read the body in Blob or JSON format.
                    return { ...file, text };
                } else {
                    return null;
                }
            })
        );

        // Filter out null values from bodies
        const filteredBodies = bodies.filter(body => body !== null);

        // console.log('All files:', filteredBodies);
        return filteredBodies.map(x => JSON.parse(x.text));
    } catch (error) {
        console.error('Error fetching file URLs:', error);
        return [];
    }
};

export default GetStories;